import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import useInAppNavigate from '../../hooks/router/use-in-app-navigate';
import { getRestartLinkPath } from '../../redux/selectors/authProgress';
import { getIsAuthenticated } from '../../redux/selectors/billing';
import { SIGNUP_NESTED } from '../../utils/router';
import LoaderOverlay from '../overlay/loader-overlay';

// KU – an authenticated user shouldn't end up on this route, but if for some
// reason they do, redirect them accordingly
export default function UnauthenticatedRoute() {
  // KU – we only care about the value of isAuthenticated on mount
  const { current: isAuthenticated } = useRef(useSelector(getIsAuthenticated));
  const restartPath = useSelector(getRestartLinkPath) || SIGNUP_NESTED;
  const navigate = useInAppNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      // KU – redirect should only happen once!!!
      navigate(restartPath, { replace: true });
    }
  }, []);

  return (
    <Choose>
      <When condition={isAuthenticated}>
        <LoaderOverlay />
      </When>
      <Otherwise>
        <Outlet />
      </Otherwise>
    </Choose>
  );
}
